import React from 'react';
import {
    Box, TextField, FormControl, InputAdornment, InputLabel, Input, IconButton, Button,
    Typography, Select, MenuItem, FormHelperText, Alert, Tab, Tabs
} from '@mui/material';
import { AccountCircleOutlined, Visibility, VisibilityOff, LockOutlined, Group } from '@mui/icons-material';
import { useState, useEffect } from 'react';
import { useSelector, useDispatch, } from 'react-redux';
import { set } from 'lodash';
import { Grid } from '../../components/table';
import { CONFIG } from '../../../config'
import axios from 'axios';
import { ToolBar } from '../../components/toolbar';
import { Modal } from '../../components/modal';
import { FormA } from '../../components/form';
import moment from 'moment';
import {getFormState} from '../../../helpers/form';
import dayjs from 'dayjs';
import IosShareIcon from '@mui/icons-material/IosShare';
import PropTypes from 'prop-types';


const API_HOST = CONFIG.modules['accounts'].host
const API_HOST_CRM = CONFIG.modules['crm'].host

function CustomTabPanel(props) {
	const { children, value, index, ...other } = props;

	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`simple-tabpanel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
			{...other}
		>
			{value === index && (
				<Box sx={{ p: 1 }}>
					<Typography>{children}</Typography>
				</Box>
			)}
		</div>
	);
}

CustomTabPanel.propTypes = {
	children: PropTypes.node,
	index: PropTypes.number.isRequired,
	value: PropTypes.number.isRequired,
};

function a11yProps(index) {
	return {
		id: `simple-tab-${index}`,
		'aria-controls': `simple-tabpanel-${index}`,
	};
}

export const FollowUpList = (props) => {
	const [value, setValue] = React.useState(0);

	const handleChange = (event, newValue) => {
		setValue(newValue);
	};
	return (
		<Box sx={{ width: '100%' }}>
			<Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
				<Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
					<Tab label="CALL DUE" {...a11yProps(0)} />
					<Tab label="CALL OVERDUE" {...a11yProps(1)} />
					
				</Tabs>
			</Box>
			<CustomTabPanel value={value} index={0} >
				<List heading={'Due List'} type={'due'}/>
			</CustomTabPanel>
			<CustomTabPanel value={value} index={1}>
				<List heading={'Overdue List'} type={'overdue'}/>
			</CustomTabPanel>
			
		</Box>
	)
}



export const List = ({heading, type}) => {
    const { roles, user, users, Designations, Departments, Languages, Districts } = useSelector((state) => (state.user || {}))
    const userStore = useSelector((state) => (state.user || {}))

    const [active, setActive] = useState('Employees')
    const [data, setData] = useState([])
    const [open, setOpen] = useState(false)
    const [action, setAction] = useState('new')
    const [saved, setSaved] = useState(null);
    const [index, setIndex] = useState(null);
    const [openConfirm, setOpenConfirm] = useState(false)
    const [selectedSankalpData, setSelectedSankalpData] = useState(null)

    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(25);
    const [count, setCount] = useState(0)
    const [filter, setFilter] = useState({
        from: dayjs('01-01-2023'),
        to: dayjs(),
    })



    const getList = () => {
        setData([])
        axios.get(API_HOST_CRM + `/cases?limit=${rowsPerPage}&page=${page}&type=${type}${
            filter.from?`&from=${dayjs(filter.from).format('YYYY-MM-DD')}`:''
            }${filter.to?`&to=${dayjs(filter.to).format('YYYY-MM-DD')}`:''}
            ${filter.district?`&district=${filter.district}`:''}
            ${filter.dataType?`&dataType=${filter.dataType}`:''}
            `)
        .then((resp) => {
            if (resp.data && resp.data.success) {
                setData(resp.data.cases)
                setCount(resp.data.count)
            }

        }).catch((e) => {

            console.log(e)
        })
    }

    useEffect(()=>{
        getList()
    },[page,rowsPerPage, filter])


    useEffect(() => {
        getList()
    }, [])




    return (
        <>
         <ToolBar name={heading} buttons={[
                // {
                //     name: 'Export',
                //     // type: 'chip',
                //     icon: () => <IosShareIcon sx={{ fontSize: '1.2em' }} />,
                //     onClick: () => {
                //     }
                // }
            ]}

            filters={[
                    // {
                    //     field: {
                    //         name: 'dataType',
                    //         type: 'select',
                    //         label: 'DataType',
                    //         option: { key: 'dataType', value: '_id', label: 'name' },

                    //     },
                    //     data:{
                    //         dataType:[
                    //         {
                    //             _id: 'Any',
                    //             name: 'Any'
                    //         },
                    //         {
                    //             _id: 'New Data',
                    //             name: 'New Data'
                    //         },
                    //         {
                    //             _id: 'Follow Ups',
                    //             name: 'Follow Ups'
                    //         },
                    //        ]
                    //     },
                    //     onChange: (name, value) => {
                    //         filter[name] = value
                    //         setFilter({...filter})
                    //     },
                    //     state: filter

                    // },
                // {
                //     field: {    
                //         name: 'district',
                //         type: 'select',
                //         label: 'District',
                //         option: { key: 'Districts', value: '_id', label: 'name' },

                //     },
                //     data:{
                //        Districts:[
                //         {
                //             _id: 'Any',
                //             name: 'Any'
                //         },
                //         ...Districts
                //        ]
                //     },
                //     onChange: (name, value) => {
                //         filter[name] = value
                //         setFilter({...filter})
                //     },
                //     state: filter

                // },
                // {
                //     field: {
                //         name: 'from',
                //         type: 'date',
                //         label: 'From',
                //     },
                //     onChange: (name, value) => {
                //         filter[name] = value
                //         setFilter({...filter})
                //     },
                //     state: filter

                // },
                // {
                //     field: {
                //         name: 'to',
                //         type: 'date',
                //         label: 'To',
                //     },
                //     onChange: (name, value) => {
                //         filter[name] = value
                //         setFilter({...filter})
                //     },
                //     state: filter

                // }
            ]} 

                 />
            <Box sx={{ mt: 2 }}>
                <Grid data={data} columns={[
                     { id: 'motherID', label: 'Mother ID', minWidth: 70 },
                        { id: 'name', label: 'Name', minWidth: 70 },
                       
                        { id: 'contact', label: 'Contact', minWidth: 70, format: (data, row) => {
                            if(row) {
                               if(row.contactNumbers && row.contactNumbers.length>0) {
                                    return row.contactNumbers.join(",")
                               } else {
                                return data||''
                               }
                            } else {
                                return ''
                            }
                        }  },
                        { id: 'districtName', label: 'District', minWidth: 50 },
                        { id: 'langName', label: 'Language', minWidth: 70, format: (data, row)=>{
                            return data||'NA'
                        } },
                        // { id: 'priority', label: 'Priority', minWidth: 70, format: (data, row)=>{
                        //     return ''
                        // } },
                        ...(type == 'overdue'?[
                            { id: 'delay', label: 'Delay Time', minWidth: 70, format: (data, row)=>{
                                return  (row.nextCallDue?dayjs(dayjs().format('YYYY-MM-DD')).diff(dayjs(row.nextCallDue).format('YYYY-MM-DD'),'day'):0) + ` Days`
                            } },
                            { id: 'delayReason', label: 'Delay Reason', minWidth: 70, format: (data, row)=>{
                                if(row.state == 'Unalloted') {
                                    return 'Never got assigned'
                                }
                                if(row.state == 'Alloted') {
                                    return `Assigned,${row.status}`
                                }
                                return ''
                            } },
                        ]:[]),
                      
                        { id: 'state', label: 'Allocation Status', minWidth: 70, format: (data, row)=>{
                            return data=='Alloted'?'Assigned': 'Unassigned'
                        } },
                        { id: 'status', label: 'Call Status', minWidth: 70, format: (data, row)=>{
                            return data || 'NA'
                        } },
                        { id: 'lastCallDate', label: 'Last Call Date', minWidth: 70, format: (data, row)=>{
                            return data?dayjs(data).format('DD-MM-YYYY'):'NA'
                        } },
                        // { id: 'sankalpId', label: 'Sankalp Data', minWidth: 50, format: (data, row) => {
                        //     if(data) {
                        //         return (<Button onClick={() => {
                        //             setOpen(true)
                        //             setSelectedSankalpData(data)
                        //         }}>View</Button>)
                        //     } else {
                        //         return ''
                        //     }
                        // } },
                        // { id: 'followUps', label: 'DataType', minWidth: 50, format: (data, row) => {
                        //     return data==true?'Follow Up':'New Data'
                        // } },

                        // { id: 'type', label: 'Type', minWidth: 50 },
                        // { id: 'allocatedTo', label: 'AllocatedTo', minWidth: 70 },
                       
                        // { id: 'createdAt', label: 'Created', minWidth: 70, format: (data, row)=>{
                        //     return data?dayjs(data).format('DD-MM-YYYY'):''
                        // } },
                   
                ]}
                pagination={{
                    rowsPerPageOptions: [10, 25, 50],
                    page,
                    rowsPerPage,
                    onPageChange: (event, newPage) => {
                        setPage(newPage);
                    },
                    onRowsPerPageChange: (event) => {
                        setRowsPerPage(+event.target.value);
                        setPage(0);
                    },
                    count
                }}
                    // actions={[]}
                    >

                    </Grid>
            </Box>

            <Modal open={open}
                handleClose={() => { setOpen(false) }}
                head={`Sankalp Data`}
                buttons={[
                    {
                        name: 'Cancel',
                        onClick: () => {
                            setOpen(false)
                        }
                    },
                 
                ]}

            >
                 
                {
                    selectedSankalpData&& selectedSankalpData.sankalpData&&
                    Object.keys(selectedSankalpData.sankalpData).map((s,i) => {
                        const map = {
                            'pregStatus': 'Pregnancy Status',
                            'advice': 'Advice',
                            'pregnancyNumber': 'Pregnancy Number',
                            'pretermDelivery': 'Pre-term Delivery',
                            'nearResidance': 'Near By Residence',
                            'trimester': 'Trimester'
                        }
                        return (
                            <Box key={i} sx={{display: 'flex', mt:1}}>
                            <Typography variant='p'>{(map[s]||s)}: </Typography>&nbsp;
                            <Typography variant='p' sx={{color: 'grey', fontSize: '.9em'}}>{selectedSankalpData.sankalpData[s]}</Typography>
                        </Box>
                        )
                    })
                }
               

            </Modal>
           
        </>
    )
}